import React from "react";
import { Box } from "@mui/material";
import { useTranslation } from "react-i18next";
import InputCst from "@components/InputCst/InputCst";
import { WizardStepProps } from "@components/WizardCst/types";
import { ActivityWizardData } from "../../../../types";

const BrightcoveContent: React.FC<WizardStepProps<ActivityWizardData>> = ({
  data,
  setData,
  errors,
}) => {
  const { t } = useTranslation("wizard-activity");

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
      <InputCst
        id="activity-brightcove-id"
        label={`${t("content.brightcove.url")} *`}
        placeholder={t("content.brightcove.url-placeholder") || ""}
        value={data.external_file_url}
        onChange={(e: any) => setData({ external_file_url: e.target.value })}
        error={!!errors.external_file_url}
        errorMessage={
          errors.external_file_url
            ? t(`errors.${errors.external_file_url}`) || ""
            : ""
        }
      />
    </Box>
  );
};

export default BrightcoveContent;
